import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Card } from "@mui/material";
import SideNav from "../../../components/sideNav";
import ClientDashboard from "./ClientDashboard";
import CompanyPerformanceChart from "./CompanyPerformanceChart";
import RecentActivitiesTable from "./RecentActivitiesTable";
import ParentWrapper from "../../../components/ParentWrapper";
import Header from "../../../components/header";

function SuperAdminDashboard() {
  return (
    // <Box>
    //   <Box>
    //     {/* <SideNav /> */}
    //     <Box
    //       sx={{
    //         ml: {
    //           xs: "0px",
    //           md: "230px",
    //         },
    //         p:3
    //       }}
    //     >
    //       <Box
    //         sx={{
    //           mb: 2,
    //           mt: {
    //             xs: 0,
    //             md: 1,
    //           },
    //           p: 3,
    //         }}
    //       >
    //         {/* Dashboard Title */}
    //         <Typography
    //           variant="body2"
    //           style={{
    //             color: "grey",
    //           }}
    //         >
    //           {"Home > Company Access"}
    //         </Typography>
    //         <ClientDashboard />
    //         <CompanyPerformanceChart />
    //         <RecentActivitiesTable />
    //       </Box>


    //     </Box>
    //   </Box>
    // </Box>

    <ParentWrapper>
       <Box
            sx={{
              mb: 2,
              mt: {
                xs: 0,
                md: 1,
              },
              p: 3,
            }}
          >
            {/* Dashboard Title */}
            {/* <Typography
              variant="body2"
              style={{
                color: "grey",
              }}
            >
              {"Home > Company Access"}
            </Typography> */}
             <Header title={"Home > Company Access"}  />
            <ClientDashboard />
            <CompanyPerformanceChart />
            <RecentActivitiesTable />
          </Box>

    </ParentWrapper>
  );
}

export default SuperAdminDashboard;
